import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { INVITE_AGENCY_ACCOUNT_MANAGER } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default ({ email }) => async (dispatch, getState) => {
	const state = getState()

	const { error } = await invokeApiRequest(
		INVITE_AGENCY_ACCOUNT_MANAGER, { email }, state,
	)

	if (error) {
		throw error
	}
}
